import { Tag } from "@chakra-ui/react";
import CommonTable from "../../../common/mytable";
import SortableHeaderLabel from "../../../common/SortableHeaderLabel";
import { getStatusColor, getWorkTypeColor } from "../utils/approvePresentation";

const getColumns = ({ sortField, sortOrder, onSort }) => [
  {
    key: "name",
    label: (
      <SortableHeaderLabel sortKey="name" sortField={sortField} sortOrder={sortOrder} onSort={onSort}>
        이름
      </SortableHeaderLabel>
    ),
    render: (value) => <strong>{value}</strong>,
  },
  {
    key: "workType",
    label: "근무구분",
    render: (value) => (
      <Tag size="sm" colorScheme={getWorkTypeColor(value)} borderRadius="full">
        {value || "근무"}
      </Tag>
    ),
  },
  {
    key: "status",
    label: "상태",
    render: (value) => (
      <Tag size="sm" colorScheme={getStatusColor(value)} borderRadius="full">
        {value}
      </Tag>
    ),
  },
  {
    key: "date",
    label: (
      <SortableHeaderLabel sortKey="date" sortField={sortField} sortOrder={sortOrder} onSort={onSort}>
        근무일
      </SortableHeaderLabel>
    ),
  },
  {
    key: "totalWorkDisplay",
    label: (
      <SortableHeaderLabel sortKey="totalWorkMinutes" sortField={sortField} sortOrder={sortOrder} onSort={onSort}>
        총근무시간
      </SortableHeaderLabel>
    ),
    render: (value, row) => value || row.totalWorkHM || "-",
  },
  {
    key: "location",
    label: "근무지",
    render: (value) => value || "-",
  },
];

export default function ApproveDesktopTable({ rows, selectedIds, toggleAll, toggleOne, onRowClick, sortField, sortOrder, onSort, selectableIds, selectedOnPageCount }) {
  const columns = getColumns({ sortField, sortOrder, onSort });
  const checkedItems = Object.fromEntries(rows.map(row => [row.id, selectedIds.has(row.id)]));
  const disabledRowIds = new Set(rows.filter(row => row.canApprove === false).map(row => row.id));
  return (
    <CommonTable
      columns={columns}
      data={rows}
      rowKey="id"
      selectable
      checkedItems={checkedItems}
      disabledRowIds={disabledRowIds}
      selectAll={{
        isChecked: selectableIds.length > 0 && selectedOnPageCount === selectableIds.length,
        isIndeterminate: selectedOnPageCount > 0 && selectedOnPageCount < selectableIds.length,
        isDisabled: selectableIds.length === 0,
        onChange: (checked) => toggleAll(checked, selectableIds),
      }}
      onCheck={(id) => {
        toggleOne(id, !selectedIds.has(id));
      }}
      onRowClick={onRowClick}
    />
  );
}
